export default __webpack_public_path__ + "static/media/antelope2Klein.8cc3dda5.jpg";